<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        02.14
        <br>2020
      </span>
      <span class="tiel">【经济日报】美菜启动紧急助销计划 瑞安滞销菜有救了</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        <p>战“疫”当下，浙江温州瑞安市陶山镇除了对疫情担忧外，更让当地农民伤心的是地里无人问津的蔬菜。</p>
      </div>
      <div class="tet-js">
        <p>作为温州地区闻名遐迩的果蔗之乡——瑞安市陶山镇产的蔬菜一直都是市场上的抢手货。但眼下，由于温州疫情防控形势极其严峻，陶山镇为防止疫情传播交通封锁，导致大批农产品待销，当地菜农面临巨大损失。一位当地农户表示：“这个时候，我们陶山镇农民本来不想给大伙儿添麻烦，但是辛辛苦苦种出来的蔬菜，就这样烂在地里，实在很心疼！希望能够帮帮我们。”</p>
        <br>
        <p>“我们试了很多种方法，比如镇政府牵头采购蔬菜，还联系镇新乡贤联谊会共同采购当地蔬菜，但是依然杯水车薪。”陶山镇纪委书记彭建国说。据了解，陶山镇本次滞销蔬菜以花菜、黄瓜、西红柿、长茄、娃娃菜为主，滞销总量近7万斤，滞销情况已经不是“自救”可以解决的了。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_14.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">瑞安陶山镇七甲村农户地里滞销的花菜</div>

      <div class="tet-js">
        <p>美菜网杭州大区总经理邓昕得知陶山镇滞销情况后，立即决定启动美菜SOS（紧急助销计划）。“温州美菜去年联合杭州美菜、宁波美菜启动过SOS，温州有经验、也有责任把这次任务完成好！”邓昕说。</p>
        <br>
        <p>本次瑞安陶山SOS项目执行最大的困难就是交通，沿路出入陶山镇的公路已经全部关闭。项目组立刻分别与温州和瑞安陶山镇的政府部门进行沟通说明，仅用两天时间即获得了政府支持及运输通行证明。2月12日上午，经现场考察确认，温州美菜最终确定首批助销滞销最严重的1万斤西红柿和1万斤花菜，并即时发往温州仓库，同时向上报备，考虑后续助销方案。</p>
        <br>
        <p>但是，新的情况又出现了，因为不能有太多人员聚集，如何对滞销菜进行集中装拣是此次SOS助销遇到的另一大难题。“农户得知后，他们开始一户一户分别骑着三轮车、自行车甚至马车，把蔬菜拉到收菜点，帮助我们解决了很多问题，而且现场非常有序，农户也非常配合我们的工作。”美菜温州负责人石建明说。</p>
        <br>
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_15.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">温州美菜SOS项目组完成使命</div>
      <div class="tet-js">
        <p>一位受滞销影响最为严重的农户说：“美菜能够在这个困难重重的特殊时期，来到这里帮助我们，减少我们的损失，我们非常感激。”8个小时之后，温州美菜在瑞安完成了助销菜品的初步分拣、装包后，援助车辆连夜启程驶向温州市区。</p>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
